export default __webpack_public_path__ + "static/media/Redtalon Gauntlets.b067c17a.jpg";